'use client';

import Screen from 'icons/lib/screen.svg';
import Tv from 'icons/lib/tv.svg';
import Link from 'next/link';
import { Trans } from 'react-i18next';
import { Button } from 'ui';

import { useTranslation } from '@/i18n/client';

import styles from './ServerError.module.scss';

export const ServerError = () => {
  const { t } = useTranslation(['error', 'common']);

  return (
    <div className={styles.serverError}>
      <div className="container">
        <span className={styles['serverError--errorTitle']}>
          {t('error.title')}
        </span>
        <div className={styles.serverError__svgPlace}>
          <Tv className={styles['serverError__svgPlace--tv']} />
        </div>
        <div className={styles.serverError__screenPlace}>
          <Screen className={styles['serverError__screenPlace--screenSvg']} />
        </div>
        <h1 className={styles['serverError--title']}>
          {t('serverError.title')}
        </h1>
        <p className={styles['serverError--description']}>
          <Trans
            i18nKey="serverError.description"
            t={t}
            components={[<br key={0} />]}
          />
        </p>
        <Button
          buttonName="backButton"
          variant="blue"
          as={Link}
          prefetch={false}
          href="/"
        >
          {t('common:common.goToHomePage')}
        </Button>
      </div>
    </div>
  );
};
